module.exports = __webpack_public_path__ + "img/25.b68fde84.jpg";